import { createFileRoute } from "@tanstack/react-router"
import { ValidateAuthenticationFactorStack } from "@/routes/-components/user-authentication-factor/validate-authentication-factor-stack"
import { useTranslation } from "react-i18next"
import { AuthContainer } from "../../-components/auth-container"
import { useQueryClient } from "@tanstack/react-query"

export const Route = createFileRoute("/authenticate/mfa/$id/register")({
  component: Register,
})

export function Register() {
  const userAuthenticationFactorId = parseInt(Route.useParams().id)
  const queryClient = useQueryClient()
  const navigate = Route.useNavigate()
  const { t } = useTranslation("app_server")

  return (
    <AuthContainer
      title={t("UserAuthenticationFactor_ConfirmAuthenticationFactor")}
    >
      <ValidateAuthenticationFactorStack
        onSuccess={() => {
          queryClient.invalidateQueries()

          navigate({ to: "/app/dashboard" })
        }}
        onCancel={() => {
          navigate({
            to: "/authenticate/login",
            search: { returnUrl: undefined },
          })
        }}
        userAuthenticationFactorId={userAuthenticationFactorId}
      />
    </AuthContainer>
  )
}
